<template>
    <div class="aps-dashboard">
        <div>
            <b-overlay
                variant="white"
                :show="report_data.data == null"
                spinner-variant="primary"
                blur="0"
                opacity=".75"
                rounded="sm"
                style="height: 100vh;"
            >
                <div class="row" style="justify-content: center; margin: 10px;">
                    <div style="display: flex; align-items: center;">
                        日期範圍
                    </div>
                    <flat-pickr
                        v-model="date"
                        class="form-control"
                        placeholder="Select date"
                        :config="{
                            mode: 'range'
                        }"
                    />
                </div>
                <div v-if="report_data.data != null">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <ApexLineChart
                                :Data="report_data.data.data_1"
                                :Option="{
                                    title: '平均交期',
                                    subtitle: ''
                                }"
                                ref="rp_1"
                                :BaseDate="baseDate"
                                @chartUpdate = "(val)=>{ rp[0] = val }"
                            />
                        </div>
                        <div class="col-12 col-md-6">
                            <ApexDataBarChart
                                :Data="report_data.data.data_2"
                                :Option="{
                                    title: '校正差異週數',
                                    subtitle: '第一次交期跟動態交期做比對'
                                }"
                                ref="rp_2"
                                @chartUpdate = "(val)=>{ rp[1] = val }"
                            />
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <ApexDataBarChart
                                :Data="report_data.data.data_3"
                                :Option="{
                                    title: '校正訊息筆數'
                                }"
                                ref="rp_3"
                                @chartUpdate = "(val)=>{ rp[2] = val }"
                            />
                        </div>
                        <div class="col-12 col-md-6">
                            <ApexHeatMapChart
                                :Data="report_data.data.data_4"
                                :Option="{
                                    title: '校正錯誤統計'
                                }"
                                ref="rp_4"
                                @chartUpdate = "(val)=>{ rp[3] = val }"
                            />
                        </div>
                    </div>
                    <div class="row report">
                        <div class="report-title">
                            校正報表(8天)
                        </div>
                        <div class="report-body" v-for="report_title, j in report_data.data.data_5" :key="j">
                            <div v-for="item, i in report_title" :key="i">
                                <div v-if="j === 0" class="report-body-column">
                                    {{item.name}}
                                </div>
                                <div class="report-body-row">
                                    {{item.value}}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </b-overlay>
        </div>
    </div>
</template>
<script>
import api from './api.js'
import tools from '@/sag-core/tools.js'
import { BButton, BRow, BCol, BFormInput, BFormGroup, BCard, BOverlay } from 'bootstrap-vue'
import ApexLineChart from './components/ApexLineChart.vue'
import ApexDataBarChart from './components/ApexDataBarChart.vue'
import ApexHeatMapChart from './components/ApexHeatMapChart.vue'
import EchartBar from './components/EchartBar.vue'
import data from './data.json'
import flatPickr from 'vue-flatpickr-component'
import { ref, watch, reactive, getCurrentInstance, nextTick } from '@vue/composition-api'
export default {
    name: 'APSDashboard',
    components: {
        BButton,
        BRow,
        BCol,
        BCard,
        BFormInput,
        BFormGroup,
        ApexLineChart, // 折線圖
        ApexDataBarChart, // 直線圖
        ApexHeatMapChart, // 點陣圖
        EchartBar, // 直線圖
        flatPickr,
        BOverlay,
    },
    setup(props, ctx) {
        let vue = getCurrentInstance()
        let start = new Date(new Date().setDate(new Date().getDate() - 8)).toJSON().split('T')[0]
        let end = new Date().toJSON().split('T')[0]
        const date = ref([start, end])
        const baseDate = ref(new Date(new Date(start).getFullYear(), 1, 1))
        const rp = ref([])
        class Data {
            _data = null
            get data(){
                return this._data
            }
            set data(value){
                this._data = value
            }

            test(){
                this._data = data
            }
        }
        let report_data = reactive(new Data())

        watch(date, (o, n)=>{
            var pair = date.value.split('to')
            if(pair.length === 2){
                let start = pair[0].trim()
                let end = pair[1].trim()
                baseDate.value = new Date(new Date(new Date(start).getFullYear(), 1, 1))
                api.GetData(start, end).then(p=>{
                    report_data.data = p

                    nextTick(()=>{
                        rp.value.forEach(func => {
                            func()
                        })
                    })
                })
            }
        })

        api.GetData(start, end).then(p=>{
            report_data.data = p
        })

        return {
            report_data,
            date,
            rp,
            baseDate,
        }
    }
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
$report-style-color: #eeeeee;
.aps-dashboard {
    margin: 1em;
}
.report {
    margin: 0;
    background: white;
    width: 100%;
    // height: 30vh;
    border-radius: 10px;
    border: 1px $report-style-color solid;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 5px 5px $report-style-color;
    .report-title {
        height: 50px;
        font-size: 18px;
        padding: 10px;
        font-family: "Montserrat", Helvetica, Arial, serif;
    }
    .report-body {
        display: flex;
        // height: calc(100% - 50px);
        & > div {
            display: flex;
            flex-direction: column;
            flex: 1 1 0px;
            text-align: center;
            border: 1px $report-style-color solid;
        }
        .report-body-row {
            // height: 80%;
            flex-grow: 1;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .report-body-column {
            border: 1px $report-style-color solid;
        }
    }
}
</style>
